export default class PushServiceHandler {

  constructor (panel, socket, user) {
    this.panel = panel;
    this.socket = socket;
    this.user = user;
    this.listeners = {};
  }

  run () {
    const self = this;

    this.socket.on('connect', () => {
      this.emit(self.panel.event.IDENTITY, {
        register_id: self.user.register_id,
        screen_name: self.user.screen_name
      });
    });

    this.socket.on(this.panel.event.IO_TOKEN, (data) => {
      self.token = data.token;
      self.panel.setSocketIOToken(self.token, 'PushServiceHandler');
    });

    this.socket.on(this.panel.event.MESSAGE, (data) => {
      if (self.listeners[self.panel.event.MESSAGE]) {
        for (let i in self.listeners[self.panel.event.MESSAGE]) {
          (self.listeners[self.panel.event.MESSAGE][i])(data);
        }
      }
    });

    this.socket.on(this.panel.event.TYPING, (data) => {
      if (self.listeners[self.panel.event.TYPING]) {
        for (let i in self.listeners[self.panel.event.TYPING]) {
          (self.listeners[self.panel.event.TYPING][i])(data);
        }
      }
    });

    this.socket.on(this.panel.event.NEWS, (data) => {
      if (self.listeners[self.panel.event.NEWS]) {
        for (let i in self.listeners[self.panel.event.NEWS]) {
          (self.listeners[self.panel.event.NEWS][i])(data);
        }
      }
    });
  }

  addListener (event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    if (this.listeners[event].indexOf(callback) === -1) {
      this.listeners[event].push(callback);
    }
  }

  getToken () {
    if (!this.token) {
      this.token = this.panel.getSocketIOToken();
    }
    return this.token;
  }

  emit (event, payload) {
    const self = this;
    let data = {
      payload,
      token: self.getToken(),
      headers: self.panel.headers
    }
    this.socket.emit(event, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/PushServiceHandler.js